import ValidationType from 'views/components/Validation/CreateValidation/ValidationType/ValidationType';

export default ValidationType;
